import * as React from "react"
import * as styles from "./styles.module.scss"
import ericWilson200w_103018 from "./img/eric-wilson-200w-103018.jpg"
import ericWilson400w_103018 from "./img/eric-wilson-400w-103018.jpg"
import erikBernhardsson200w_103018 from "./img/erik-bernhardsson-200w-103018.jpg"
import erikBernhardsson400w_103018 from "./img/erik-bernhardsson-400w-103018.jpg"
import howardKatzenberg200w_103018 from "./img/howard-katzenberg-200w-103018.jpg"
import howardKatzenberg400w_103018 from "./img/howard-katzenberg-400w-103018.jpg"
import jerrySelitto200w_103018 from "./img/jerry-selitto-200w-103018.jpg"
import jerrySelitto400w_103018 from "./img/jerry-selitto-400w-103018.jpg"
import patriciaKorthmcdonnell200w_103018 from "./img/patricia-korthmcdonnell-200w-103018.jpg"
import patriciaKorthmcdonnell400w_103018 from "./img/patricia-korthmcdonnell-400w-103018.jpg"
import paulaTuffin200w_103018 from "./img/paula-tuffin-200w-103018.jpg"
import paulaTuffin400w_103018 from "./img/paula-tuffin-400w-103018.jpg"
import seanHundtofte200w_103018 from "./img/sean-hundtofte-200w-103018.jpg"
import seanHundtofte400w_103018 from "./img/sean-hundtofte-400w-103018.jpg"
import shawnLow200w_103018 from "./img/shawn-low-200w-103018.jpg"
import shawnLow400w_103018 from "./img/shawn-low-400w-103018.jpg"
import viralShah200w_103018 from "./img/viral-shah-200w-103018.jpg"
import viralShah400w_103018 from "./img/viral-shah-400w-103018.jpg"
import vishalBhalla200w_103018 from "./img/vishal-bhalla-200w-103018.jpg"
import vishalBhalla400w_103018 from "./img/vishal-bhalla-400w-103018.jpg"
import vishalGarg200w_103018 from "./img/vishal-garg-200w-103018.jpg"
import vishalGarg400w_103018 from "./img/vishal-garg-400w-103018.jpg"

const LeadershipTeam: React.FC = () => {
  return (
    <section className={styles.leadershipTeam}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Leadership team</h2>
        </div>
        <ul className={styles.list}>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={vishalGarg200w_103018}
                  srcSet={`${vishalGarg400w_103018} 400w, ${vishalGarg200w_103018} 200w`}
                  sizes="12vw"
                  alt="Vishal Garg"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Vishal Garg</div>
              <div className={styles.role}>Founder + CEO</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={erikBernhardsson200w_103018}
                  srcSet={`${erikBernhardsson400w_103018} 400w, ${erikBernhardsson200w_103018} 200w`}
                  sizes="12vw"
                  alt="Erik Bernhardsson"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Erik Bernhardsson</div>
              <div className={styles.role}>CTO</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={patriciaKorthmcdonnell200w_103018}
                  srcSet={`${patriciaKorthmcdonnell400w_103018} 400w, ${patriciaKorthmcdonnell200w_103018} 200w`}
                  sizes="12vw"
                  alt="Patricia Korth-McDonnell"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Patricia Korth-McDonnell</div>
              <div className={styles.role}>CMO</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={howardKatzenberg200w_103018}
                  srcSet={`${howardKatzenberg400w_103018} 400w, ${howardKatzenberg200w_103018} 200w`}
                  sizes="12vw"
                  alt="Howard Katzenberg"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Howard Katzenberg</div>
              <div className={styles.role}>CFO</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={viralShah200w_103018}
                  srcSet={`${viralShah400w_103018} 400w, ${viralShah200w_103018} 200w`}
                  sizes="12vw"
                  alt="Viral Shah"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Viral Shah</div>
              <div className={styles.role}>Head of Capital Markets</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={paulaTuffin200w_103018}
                  srcSet={`${paulaTuffin400w_103018} 400w, ${paulaTuffin200w_103018} 200w`}
                  sizes="12vw"
                  alt="Paula Tuffin"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Paula Tuffin</div>
              <div className={styles.role}>CCO</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={ericWilson200w_103018}
                  srcSet={`${ericWilson400w_103018} 400w, ${ericWilson200w_103018} 200w`}
                  sizes="12vw"
                  alt="Eric Wilson"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Eric Wilson</div>
              <div className={styles.role}>Head of Operations</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={shawnLow200w_103018}
                  srcSet={`${shawnLow400w_103018} 400w, ${shawnLow200w_103018} 200w`}
                  sizes="12vw"
                  alt="Shawn Low"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Shawn Low</div>
              <div className={styles.role}>Head of Business Operations</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={jerrySelitto200w_103018}
                  srcSet={`${jerrySelitto400w_103018} 400w, ${jerrySelitto200w_103018} 200w`}
                  sizes="12vw"
                  alt="Jerry Selitto"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Jerry Selitto</div>
              <div className={styles.role}>President</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={seanHundtofte200w_103018}
                  srcSet={`${seanHundtofte400w_103018} 400w, ${seanHundtofte200w_103018} 200w`}
                  sizes="12vw"
                  alt="Sean Hundtofte"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Sean Hundtofte</div>
              <div className={styles.role}>Chief Economist</div>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.figurePadding}>
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={vishalBhalla200w_103018}
                  srcSet={`${vishalBhalla400w_103018} 400w, ${vishalBhalla200w_103018} 200w`}
                  sizes="12vw"
                  alt="Vishal Bhalla"
                />
              </figure>
            </div>
            <div className={styles.description}>
              <div className={styles.name}>Vishal Bhalla</div>
              <div className={styles.role}>GM Insurance</div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default LeadershipTeam
